// extracted by mini-css-extract-plugin
export default {"PropertyRating":"PropertyRating_PropertyRating__U21m6"};